module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18149/js/img/valuePropModals/ReportBuilder/ValueProp1.svg"